module.exports = __webpack_public_path__ + "img/CC.0cb86f0a.png";